export default __webpack_public_path__ + "images/ae15e73c4f13d51c9fccffc5d8a44696-4_mobile_659x494.jpg";